<template>
    <div
        class="download-manager-component"
        @keyup="closeIfEsc"
    >
        <BackgroundDocumentsChannel
            channel="BackgroundDocumentsChannel"
            @connected="connected"
            @received="received"
        />
        <button
            v-show="show_toggle"
            ref="queueToggleButton"
            type="button"
            class="download-manager-icon"
            @click="show_queue = !show_queue"
        >
            <img
                id="downloading_icon"
                :src="downloads_icon_src"
                alt="Downloads icon"
            />
            <div v-show="downloadedDocuments.length > 0" class="document-badge">
                {{ downloadedDocuments.length }}
            </div>
        </button>

        <div
            id="background_documents_status"
            ref="downloadManagerQueue"
            class="download-manager-queue"
        >
            <div class="text-center clearfix align-center">
                <div
                    id="background_document_list"
                    class="fade pop"
                    :class="show_queue ? 'show' : 'invisible'"
                >
                    <div class="arrow"></div>
                    <ul class="toolbar">
                        <li class="toolbar-list-item">
                            <span>Documents</span>
                            <button
                                type="button"
                                class="
                                    btn btn-link
                                    font-weight-normal
                                    float-right
                                    limited-font-size
                                    remove-all-link
                                "
                                @click="removeAll"
                            >
                                Remove All
                            </button>
                        </li>
                    </ul>
                    <ul class="document-list">
                        <li
                            v-for="(singleDocument, index) in documents"
                            :key="index"
                            class="queued document px-2"
                        >
                            <Document
                                :single-document="singleDocument"
                                @removeDownloadedDocument="removeDownloadedDocument(index)"
                                @removeCanceledDocument="removeCanceledDocument(singleDocument)"
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DownloadsIconSrc from 'images/downloads_icon.svg';
import axios from 'axios';
import BackgroundDocumentsChannel from 'components/channels/GenericChannel.vue';
import Document from 'components/channels/Document.vue';
axios.defaults.headers.common['X-CSRF-Token'] = document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute('content');
export default {
    components: {
        BackgroundDocumentsChannel,
        Document,
    },
    data() {
        return {
            documents: [],
            previousDocumentCount: 0,
            show_queue: false,
            show_toggle: false,
            downloads_icon_src: DownloadsIconSrc,
        };
    },
    computed: {
        downloadedDocuments: function () {
            return this.documents.filter(
                (document) => document.Status === 'complete'
            );
        },
    },
    watch: {
        'documents.length'(newLength) {
            if (newLength > this.previousDocumentCount) {
                this.bounceQueueIcon();
            }
            this.previousDocumentCount = newLength;
        }
    },
    mounted() {
        this.setupDownloadDocumentEventListeners();
        this.refreshDocumentDownloadEventListeners();
        axios
            .get('/background_documents/get_documents.json')
            .then((response) => {
                this.documents = response.data.background_documents;
                this.previousDocumentCount = this.documents.length;
                if (this.documents.length > 0) {
                    this.show_toggle = true;
                }
            })
            .catch((error) => console.log(error));
    },
    beforeUnmount() {
        $(document).off('click', 'a[data-remote-file-url]');
        $(document).off('ajax:success', '[data-remote="true"]');
    },
    methods: {
        hideQueue: function () {
            this.show_queue = false;
            this.$refs.queueToggleButton.focus();
        },
        closeIfEsc: function (e) {
            if (e.key === 'Escape' || e.keyCode === 27) {
                this.hideQueue();
            }
        },
        bounceQueueIcon: function () {
            let toggleButton = this.$refs.queueToggleButton;
            toggleButton.classList.add('rubber-bounce');
            setTimeout(() => {
                toggleButton.classList.remove('rubber-bounce');
            }, 410);
        },
        removeAll: function () {
            this.hideQueue();
            this.show_toggle = false;
            setTimeout(() => {
                axios
                .get('/background_documents/remove_all.json')
                .then(() => {
                    this.documents = [];
                })
                .catch((error) => console.log(error));
            }, 500);
        },
        connected: function () {},
        received: function (data) {
            if (data.event === 'create') {
                this.documents.push(data.document);
            } else if (data.event === 'complete' || data.event === 'error')
            {
                let index = this.documents.findIndex((doc) => {
                    return doc.Id === data.document.Id;
                });
                this.documents[index] = data.document;
            }
        },
        removeDownloadedDocument: function (documentIndex) {
            this.documents.splice(documentIndex, 1);
            if (this.documents.length < 1) {
                this.hideQueue();
                this.show_toggle = false;
            }
        },
        removeCanceledDocument: function (document) {
            axios
            .get(`/background_documents/${document.Id}/cancel.json`)
            .then((response) => {
                this.documents = response.data.background_documents;
                if (this.documents.length < 1) {
                    this.hideQueue();
                    this.show_toggle = false;
                }
            })
            .catch((error) => console.log(error));
        },
        setupDownloadDocumentEventListeners: function() {
            $(document).off('click', 'a[data-remote-file-url]');
            $(document).on('click', 'a[data-remote-file-url]', this.remote_document_link_clicked);

            console.log('[DownloadManager] Event delegation set up for a[data-remote-file-url]');
        },
        move_icon_to_menu(icon, x, y) {
            var new_x, new_y;
            var clone = icon.clone();
            var wrap = $('<div></div>');
            $('body').append(wrap);
            wrap.append(clone);
            wrap.css({
                position:'absolute',
                top:y + $('body').scrollTop(),
                left:x,
                width: icon.width(),
                height: icon.height(),
                background: 'white'
            });
            var menu = $('.download-manager-icon');
            new_y = menu.offset().top;
            new_x = menu.offset().left;
            wrap.css({
                'z-index':10000
            });
            wrap.find('img').addClass('zbounce_animate');
            setTimeout(function () {
                wrap.fadeOut( 'fast', function() {
                    wrap.hide();
                });
                $('.download-manager-icon').addClass('rubber-bounce').on('animationend', function () {
                    $('.download-manager-icon').removeClass('rubber-bounce');
                });
            }, 410);
            new_y = new_y + $('body').scrollTop();
            wrap.animate({
                'top':new_y+ 10,
                'left':new_x + 12
            });
        },
        remote_document_link_clicked: function(event) {
            event.preventDefault();
            var x, y, remote_url, anchor, document_type, document_class;
            anchor = $(event.target);
            if (event.target !== event.currentTarget) {
                anchor = $(event.target).parents('a').first();
            }
            remote_url = anchor.data('remoteFileUrl');
            document_type = anchor.data('documentType') || 'pdf';
            document_class = anchor.data('documentClass');
            axios.post(remote_url, {
                document_class: document_class,
                sort: 'desc',
                document_type: document_type
            });
            x = $(event.target).offset().left;
            y = $(event.target).offset().top;
            if (! this.show_toggle) {
                var image = anchor.find('img');
                this.show_toggle = true;
                setTimeout(() => {
                    this.move_icon_to_menu(image,x, y);
                }, 100);
            } else {
                let image = anchor.find('img');
                this.move_icon_to_menu(image,x, y);
            }
        },
        refreshDocumentDownloadEventListeners: function() {
            $(document).on('ajax:success', '[data-remote="true"]', () => {
                console.log('[DownloadManager] AJAX content loaded - event delegation will handle new links');
            });
        }
    },
};
</script>

<style lang="scss" scoped>
  @import "../../packs/stylesheets/components/background-list.scss";
</style>
